import { render } from "./ANCVisitModal.vue?vue&type=template&id=c1ca27aa&scoped=true"
import script from "./ANCVisitModal.vue?vue&type=script&lang=js"
export * from "./ANCVisitModal.vue?vue&type=script&lang=js"

import "./ANCVisitModal.vue?vue&type=style&index=0&id=c1ca27aa&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ca27aa"]])

export default __exports__